import { PathTypeAccountInfo } from 'models/commonModel';
import { useNavigate } from 'react-router-dom';
import styles from './account-header.style';
import { FaBell, FaChartPie, FaClock, FaEye, FaUser, FaUsers } from 'react-icons/fa';
interface Props {
    show: boolean;
    onHide: () => void;
}

function AccountHeader(props: Props) {
    const { show, onHide } = props;
    const navigate = useNavigate();

    const selectAccountInfo = (path: PathTypeAccountInfo) => {
        onHide();
        navigate(`/account?mode=${path}`);
    };

    const menuFake = [
        {
            title: 'Tài khoản',
            icon: FaUser,
            contentMenu: [
                { title: 'Thông tin cá nhân', path: 'personal-info' },
                { title: 'Tin nhắn', path: 'noti-inbox' },
                { title: 'Tài khoản ngân hàng', path: 'bank-account' },
                { title: 'Lịch sử nạp/rút', path: 'wl-depo-his' },
            ],
        },
        {
            title: 'Đại lý',
            icon: FaUsers,
            contentMenu: [
                { title: 'Đăng ký thành viên', path: 'agent-sign' },
                { title: 'Cấp dưới', path: 'agent-member' },
                { title: 'Liên kết đăng ký', path: 'agent-reg' },
            ],
        },
        {
            title: 'Lịch sử',
            icon: FaClock,
            contentMenu: [
                { title: 'Biến động số dư', path: 'fund-tran' },
                { title: 'Chi tiết tặng quà', path: 'present-detail' },
                { title: 'Lịch sử cược sổ xố', path: 'fund-bet' },
            ],
        },
        { title: 'Thông báo', icon: FaBell, contentMenu: [{ title: 'Tất cả thông báo', path: 'noti-all' }] },
        {
            title: 'Báo cáo',
            icon: FaChartPie,
            contentMenu: [
                { title: 'Báo cáo đại lý', path: 'stats-wl' },
                { title: 'Báo cáo nhóm', path: 'stats-general' },
                { title: 'Báo cáo hàng ngày', path: 'stats-daily' },
            ],
        },
        {
            title: 'Theo dõi nhanh',
            icon: FaEye,
            contentMenu: [
                { title: 'Nạp tiền', path: 'wl-depo' },
                { title: 'Rút tiền', path: 'wl-wdr' },
                { title: 'Đăng ký thành viên', path: 'agent-sign' },
            ],
        },
    ];

    return (
        <div className={`${styles.groupAction} ${show ? styles.groupActionOpen : ''}`}>
            <div className={styles.groupActionInner}>
                {menuFake.map((item, index) => (
                    <div className="itemMenu" key={index}>
                        <div className={`viewTitle borderRight  ${index === menuFake.length - 1 ? '' : 'borderBottom'}`}>
                            <item.icon color="#ffd98a" size={20} />
                            <p className="title">{item.title}</p>
                        </div>

                        <div className={`contentMenu ${index === menuFake.length - 1 ? '' : 'borderBottom'}`}>
                            {item.contentMenu.map((i, ic) => (
                                <div
                                    onClick={() => {
                                        if (i.path) {
                                            selectAccountInfo?.(i.path as any);
                                        }
                                    }}
                                    className="itemContentMenu"
                                    key={ic}
                                >
                                    <p className="titleContent">{i.title}</p>
                                    {ic < item.contentMenu.length - 1 && <div className="line"></div>}
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default AccountHeader;
